export default {"src":"/_next/static/media/icon-blueprints.3284ccab.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};